import { Box, Stack, Typography } from '@mui/material'
import { styled } from '@mui/material/styles'
import { EditMessageIcon } from '$common/icons/edit-message'
import { t } from '$i18n'

const StyledStack = styled(Stack)`
  overflow: hidden;
  margin: 9px 0 8px 0;
`

const StyledTitle = styled(Typography)`
  margin-right: 4px;
  font-size: 13px;
  line-height: 19.5px;
  font-weight: 700;
`

const StyledDescription = styled(Typography)(({ theme }) => ({
  ...theme.typography.paragraph3,
  lineHeight: '19.5px',
  color: theme.palette.semiLightGray,
}))
interface Props {
  body: string
}
export function EditText({ body }: Props) {
  return (
    <StyledStack justifyContent="center">
      <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: '2px' }}>
        <EditMessageIcon />
        <StyledTitle color="primary">{t('chat.editMessage')}</StyledTitle>
      </Box>
      <StyledDescription noWrap>{body}</StyledDescription>
    </StyledStack>
  )
}
